// extracted by mini-css-extract-plugin
export default {"float-left":"Copyright-module--float-left--0284b","float-right":"Copyright-module--float-right--70ea1","copyright":"Copyright-module--copyright--aefad"};